import * as React from 'react';
import {ActionTeaser as VWMActionTeaser} from '@volkswagen-onehub/components-core';
import {ActionTeaserProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {Icon} from '../icon';

export function ActionTeaser({
  appearance,
  headline,
  icon,
  copy,
  onClick,
}: ActionTeaserProps) {
  const teaserIcon = icon ?? (
    <Icon name={'BatteryCalculator'} size={'medium'} />
  );
  return (
    <VWMActionTeaser
      appearance={appearance}
      headline={headline}
      icon={teaserIcon}
      copy={copy}
      onClick={onClick}
      actionIcon={<Icon name={'ChevronRight'} size={'medium'} />}
      type={'button'}
    />
  );
}
